import React from 'react'
import Image from 'next/image'
import { StyledWrapper } from '../Styled'
const about = ({ props }: any) => {
    return (
        <div>
            <div className='bg-white mt-12 mb-8 xl:w-[95%]  2xl:w-[80%] px-4  mx-auto'>
               {props?.title &&
                <h2 className='text-homeblack   font-bold '>
                    {props?.title }
                </h2>}
               {props?.subtitle&&
                <h3 className='text-homeblack text-[18px] lg:text-[20px] font-semibold leading-[29px]'>
                    {props?.subtitle }
                </h3>}
                <div className='flex justify-between  mt-6 items-start lg:gap-16'>
                    <div className={`${props?.image ? 'lg:w-1/2' : 'w-full'} `}>
                        <div className=''>
                            <StyledWrapper>
                                <div
                                    className='text-homegrey  text-[18px] mt-4'
                                    dangerouslySetInnerHTML={{ __html: props?.description || '' }}
                                />
                            </StyledWrapper>
                        </div>
                    </div>
                    {props?.image && (
                        <div className=' hidden w-1/2  rounded-xl py-3 h-inherit   lg:block '>
                            <Image
                                src={props.image || ''}
                                // src={props?.image || ''}
                                height={517}
                                width={793}
                                alt={props?.image_alt}
                                className=''
                            />
                        </div>
                    )}
                </div>
            </div>

        </div>
    )
}

export default about